import { createFileRoute } from "@tanstack/react-router";
import { Rewards } from "@/components/Rewards";

function RouteComponent() {
  return <Rewards />;
}

export const Route = createFileRoute("/_authenticated/rewards/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
